import styled from "styled-components";
import {Flex} from "./flex";

export const FlexJustifyAlignCenter = styled(Flex)`
    justify-content: center;
    align-items: center;
`;
